module.exports = "/_next/static/images/icon-check-white-830f1438a637486c602186587200efd2.svg";